import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import vi from '@angular/common/locales/vi';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import {
  CloseOutline,
  DeleteOutline,
  EditOutline,
  PlusOutline,
  RotateRightOutline,
  SaveOutline,
  SearchOutline,
  ThunderboltOutline,
  ZoomInOutline,
  ZoomOutOutline
} from '@ant-design/icons-angular/icons';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { provideNzI18n, vi_VN } from 'ng-zorro-antd/i18n';
import { NzImageService } from 'ng-zorro-antd/image';
import { NzModalService } from 'ng-zorro-antd/modal';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';

registerLocaleData(vi);

const icons = [
  PlusOutline,
  SearchOutline,
  EditOutline,
  DeleteOutline,
  ThunderboltOutline,
  CloseOutline,
  ZoomInOutline,
  ZoomOutOutline,
  RotateRightOutline,
  SaveOutline
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideNzI18n(vi_VN),
    // Notification mặc định cách top 24px nên đè lên navbar (~78px), che menu.
    // Hạ xuống dưới navbar để người dùng vẫn bấm được menu khi thông báo đang hiện.
    // Giá trị theo breakpoint khai báo ở --tnd-notification-top trong styles.css.
    provideNzConfig({ notification: { nzTop: 'var(--tnd-notification-top, 92px)' } }),
    NzImageService,
    NzModalService,
    provideNzIcons(icons)
  ]
};
